module.exports = __webpack_public_path__ + "img/image_3_mobile.5a3aeaf.jpg";